<template>
  <v-card>
    <v-card-title>{{ $t("penalities.title") }}</v-card-title>
    <v-card-text>
        <v-data-table
            :headers="headers"
            :items="this.items"
            must-sort hide-default-headers disable-pagination hide-default-footer>
        <template v-slot:item.title="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{item.title}}</span>
            </template>
            {{item.englishTitle}}
          </v-tooltip>
        </template>
        <template v-slot:item.applicationType="{item}">
          {{ applicationType(item.applicationType) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="warning" @click="showCopyDialog">{{ $t("penalities.copyFromCompetition") }}</v-btn>
      
    </v-card-actions>
    <CompetitionDialog ref="dlgCompetition" :callback="competitionSelected"></CompetitionDialog>
    <!--<v-card-actions>
      <v-btn @click="showDialog({})" color="success">
        {{ $t("ctrl.add") }}
      </v-btn>
    </v-card-actions>-->
    <!--<Category ref="dialog" />-->
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardTitle,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import Category from '../../dialogs/Category.vue'
  import CompetitionDialog from '../../dialogs/CompetitionDialog.vue'
  import fccapi from '../../fccapi'

  export default {
    name: 'FCCCompetitionPenalities',
    data: function(){
        return {
            items: [],
            
        }
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      selectedCompetition: function() {
            return this.$store.getters['competitionId'];
        },
      headers: function(){
        return [
            { text: this.$t("penalities.description"), value: "title"},
            { text: this.$t("penalities.discipline"), value: "disciplineId"},
            { text: this.$t("application.type"), value: "applicationType"},
            { text: this.$t("penalities.penalityString"), value: "penalityString"}
        ]
      }
    },
    methods: {
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        showDialog: function(id){
          this.$refs.dialog.show(id);
        },
        reload: function(){
            fccapi.competitionGet("penalities").then(d=>{
                this.items = d.data
            })
        },
        showCopyDialog: function(){
          this.$refs.dlgCompetition.show();
        },
        competitionSelected: function(competitionId){
          fccapi.post(`competitions/${this.$store.getters.competitionId}/penalities/${competitionId}`, {}).then(d => {
            this.reload();
          });
        }
    },
    mounted: function(){
        this.reload();
    },
    watch: {
        selectedCompetition() {
            console.log("changed")
            this.reload();
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardTitle,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        Category,
        CompetitionDialog
    },  
  }
</script>